const voteTypes = Object.freeze({
  for: 1,
  against: 2,
  abstain: 3,
  nsp: 4,
});

export { voteTypes };
